module.exports = __webpack_public_path__ + "img/scalpel-line-dashed.ef73413f.svg";